import React from "react";
import bgImage from "../../assets/homehero.png";
import gpsTruck from "../../assets/gpstruck1.png";
import gpsMap from "../../assets/gpstruck2.png";

export default function SupportBannerSection() {
  return (
    <section
      className="relative overflow-hidden py-12 lg:py-16"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60" />

      <div className="relative mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-12 px-6 lg:flex-row lg:gap-8">
        
        {/* Left Text */}
        <div className="w-full lg:max-w-[700px]">
          <h2 className="text-[20px] font-medium leading-[1.6] text-white sm:text-[24px] lg:text-[26px]">
            Choose <span className="text-[#df8c26]">Veyonta Track</span>Technology for reliable service
            and support that goes above and beyond. We're here
            to support you every step of the way, ensuring the
            success of your fleet business.
          </h2>
        </div>

        {/* Right Images */}
        <div className="flex w-full justify-center pl-16 sm:pl-24 lg:w-auto lg:justify-end lg:pl-0">
          <div className="relative w-[260px] sm:w-[380px] lg:w-[420px]">
            {/* Large image */}
            <img
              src={gpsMap}
              alt="GPS Tracking"
              className="h-[180px] w-full rounded-2xl object-cover shadow-2xl sm:h-[220px] lg:h-[240px]"
            />

            {/* Small image */}
            <img
              src={gpsTruck}
              alt="Truck Tracking"
              className="absolute top-1/2 -left-16 z-10 h-[120px] w-[140px] -translate-y-1/2 rounded-2xl object-cover shadow-[0_10px_30px_rgba(0,0,0,0.5)] sm:-left-24 sm:h-[150px] sm:w-[180px]"
            />
          </div>
        </div>

      </div>
    </section>
  );
}